<template>
  <div id="wrapper">
    <div id="title">
      <h1>Max Horwood</h1>
      <div id="social">
        <a href="https://github.com/MaxHorwood" target="_blank">
          <img :src="'./static/images/github.png'"/>
        </a>
        <a href="https://www.linkedin.com/in/maxfield-horwood-864068110/" target="_blank">
          <img :src="'./static/images/iconmonstr-linkedin-3-32.png'"/>
        </a>
      </div>
    </div>
    <span id="comeBack">Come back</span>
  </div>
</template>
<script>
export default {
  name: 'hello',
  setup () {},
  mounted () {
    const container = document.getElementById('wrapper')
    const title = document.getElementById('title')
    const comeBack = document.getElementById('comeBack')
    container.addEventListener('mousemove', e => {
      let middleX = container.scrollWidth / 2
      let middleY = container.scrollHeight / 2

      let left = (e.x - middleX) / 5
      let top = (e.y - middleY) / 5

      title.style.transform = `translate(${left}px, ${top}px)`

      const testX = Math.abs((e.x - middleX) / middleX)
      const testY = Math.abs((e.y - middleY) / middleY)
      comeBack.style.opacity = `${testX + testY - 0.3}`
    })
  }
}
</script>
<style lang="scss">
  * {
      margin: 0;
      padding: 0;
  }
  #wrapper {
    z-index: -1;
    display: flex;
    position: absolute;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    background-color: #101820FF;
  }
  #title {
    user-select: none;
    font-size: 4vh;
    color: #F2AA4CFF;
    transition: cubic-bezier(0.175, 0.885, 0.32, 1.275) 1s;
    display: flex;
    flex-direction: column;
    h1 {
      z-index: 10;
    }
  }
  #comeBack {
    user-select: none;
    opacity: 0;
    position: absolute;
    color: rgba(255, 255, 255, 0.15);
  }
  #social {
    display: flex;
    justify-content: center;
    transition: cubic-bezier(0.175, 0.885, 0.32, 1.275) 1s;
    a {
      padding: 0 10px;
      text-decoration: none;
      opacity: 0.5;
      transition-duration: 0.3s;
      &:hover {
        opacity: 1;
      }
    }
    img {
      width: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue